// extracted by mini-css-extract-plugin
var _1 = "TextListItemContent-moduleTextListItemContent__vzERa";
var _2 = "TextListItemContent-moduleadditionalInfoText__lXoZ1";
var _3 = "TextListItemContent-moduledisabled__JPqB8";
var _4 = "TextListItemContent-modulehover__CmtoO";
var _5 = "TextListItemContent-moduletext__ZPIEt";
export { _1 as "TextListItemContent", _2 as "additionalInfoText", _3 as "disabled", _4 as "hover", _5 as "text" }
